import React from "react";

const CardContent = ({
  data,
  title,
  subtitle,
  description,
  borderColor,
  children,
}) => {
  const panelStyle = borderColor
    ? {
        border: `2px solid ${borderColor}`,
        borderRadius: "5px",
        padding: "15px",
      }
    : {};

  return (
    <div className="col-md-6 col-sm-12 col-xs-12">
      <div className="x_panel mt-10" style={panelStyle}>
        {title && (
          <h3 style={{ marginTop: 0, fontWeight: "bold", fontSize: "18px" }}>
            {title}
          </h3>
        )}
        {subtitle && (
          <h4
            style={{
              fontWeight: "bold",
              marginTop: 0,
              marginBottom: "5px",
              fontSize: "15px",
            }}
          >
            {subtitle}
          </h4>
        )}
        {description && (
          <p
            style={{
              fontSize: "0.8em",
              textTransform: "uppercase",
              color: "#666",
              marginBottom: "12px",
              borderBottom: "1px solid #eee",
              paddingBottom: "8px",
            }}
          >
            {description}
          </p>
        )}
        {data &&
          data.map((item) => (
            <p key={item.title}>
              {item.title}: <b>{item.value}</b>
            </p>
          ))}
        {children}
      </div>
    </div>
  );
};

export default CardContent;
